import { AddAdmin } from "../../components/admins/AddAdmin.component";
import { BreadCrumbSign } from "../../components/generic/breadcrumbSign.component";
export const AdminsAddPage = () => {
  return (
    <div className="row gx-0">
      <div className="col-12 m-2">
        <div className="d-flex flex-column px-1 me-3">
          <p className="content-header ms-1">
            Admins <BreadCrumbSign /> New
          </p>
          <AddAdmin />
        </div>
      </div>
    </div>
  );
};
